import { smsConsumeRecord, errors } from '@/services';

export default {
	namespaced: true,
	state: {
		smsAssets: null,
	},
	getters: {
		haveSmsAssets(state) {
			if (state.smsAssets) {
				return state.smsAssets.isFree || state.smsAssets.remainSmsNum;
			} else {
				return false;
			}
		},
	},
	mutations: {
		SET_SMS_ASSETS(state, data) {
			state.smsAssets = data;
		},
	},
	actions: {
		async getCurrentSmsAssets({ state, commit, dispatch }, params) {
			try {
				const { data, ok } = await smsConsumeRecord.getUserSmsInfo(params);
				if (!ok) {
					return;
				}
				data.data.isFree = Date.now() < data.data.smsFreeDueDate;
				commit('SET_SMS_ASSETS', data.data);
			} catch (error) {
				errors(error);
			}
		},
	},
};
